import { useQueryClient } from '@tanstack/react-query';
import { Button, Dialog, DialogBody, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import { overlay } from 'overlay-kit';
import { getGetPlanManagementQueryOptions } from '@/api/gen/quiz-plans/quiz-plans.gen';
import { resolvePurchaseCheckoutPolicy } from '@/shared/utils/purchaseCheckoutPolicy';
export const useSchoolPurchaseGuard = () => {
  const queryClient = useQueryClient();
  const {
    t
  } = useTranslation(['common', 'billing']);
  return async () => {
    let blocked = true;
    let failed = false;
    try {
      const {
        data: management
      } = await queryClient.fetchQuery({
        ...getGetPlanManagementQueryOptions(),
        staleTime: 0,
        retry: false,
        meta: {
          ignoreError: true
        }
      });
      blocked = !resolvePurchaseCheckoutPolicy({
        entry: {
          school: true
        },
        management
      }).allowed;
    } catch {
      failed = true;
    }
    if (!blocked) return false;
    overlay.open(({
      unmount
    }) => <Dialog open onOpenChange={open => !open && unmount()}>
        <DialogContent className="w-full max-w-[400px]">
          <DialogHeader>
            <DialogTitle>
              {failed ? t('common:common.unknownError.title') : t('billing:errors.PAYMENT_NOT_ALLOWED.title')}
            </DialogTitle>
          </DialogHeader>
          <DialogBody className="h-auto px-md mobile-lg:px-lg">
            <DialogDescription>
              {failed ? t('common:common.unknownError.content') : t('billing:schoolPackage.groupBlocked')}
            </DialogDescription>
          </DialogBody>
          <DialogFooter>
            <Button size="md" className="w-full" onClick={unmount}>
              {t('common:global.confirm.button')}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>);
    return true;
  };
};